<!-- src/components/Login.vue -->
<template>
  <div class="oneThirdCol">
    <!-- Check auth status and -->
    <template v-if="authStore.isAuthenticated">
      <div class="card">
        <p>You are currently logged in</p>
        <button type="button" @click="authStore.logout">Logout</button>
      </div>
    </template>
    <template v-else>
      <div class="card">
        <h1>Sign in</h1>
        <form @submit.prevent="login_submit">
          <label for="username">Username:</label>
          <input type="text" id="username" v-model="username" />
          <br />
          <label for="password">Password:</label>
          <input type="password" id="password" v-model="password" />
          <br />
          <div>

          </div>
          <Checkbox v-model="gdprAck" label="I acknowledge stuff" />
          <br />
          <button type="submit">Submit</button>
        </form>
        <div v-if="showGDPRMessage">Please acknowledge the GDPR stuff.</div>
        <div v-if="showMissingFieldsMessage">Please fill in both username and password inputs.</div>
        <div v-if="showInvalidLoginMessage">Invalid login details. Try again.</div>
      </div>
    </template>
  </div>
  
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { useRouter } from 'vue-router'
import { ref, watch } from 'vue'

const router = useRouter()
const authStore = useAuthStore()
const showInvalidLoginMessage = ref(false)
const showMissingFieldsMessage = ref(false)

const username = ref('')
const password = ref('')

const showGDPRMessage = ref(false)
const gdprAck = ref(false)


const login_submit = async () => {
  // get username and password from the form
  // const usernameBox = document.getElementById('username') as HTMLInputElement
  // const passwordBox = document.getElementById('password') as HTMLInputElement
  // const username = usernameBox.value
  // const password = passwordBox.value
  if (!gdprAck) {
    // show a message to acknowledge the GDPR
    showGDPRMessage.value = true
  } else {
    // remove the GDPR message
    showGDPRMessage.value = false
  }

  if (username.value === '' || password.value === '') {
    // show a message to fill in both fields
    showMissingFieldsMessage.value = true
  } else {
    // remove the missing fields message
    showMissingFieldsMessage.value = false
    authStore.login(username.value, password.value).then(() => {
      console.log(authStore.isAuthenticated)
      if (username.value === '' || password.value === '') {
        // show a message to fill in both fields
        showMissingFieldsMessage.value = true
      } else {
        // remove the missing fields message
        showMissingFieldsMessage.value = false
      }

      if (authStore.isAuthenticated) {
        // redirect to the home page
        // remove the invalid login message
        showInvalidLoginMessage.value = false
        router.push('/')
      } else {
        // show an error message
        showInvalidLoginMessage.value = true
      }
    })
  }
}

// Add a watcher to remove the error message when the user types in the username or password
watch([username, password], () => {
  showInvalidLoginMessage.value = false
  showMissingFieldsMessage.value = false
})
</script>

<style scoped>
.oneThirdCol {
  width: 33.3333%;
  /* centre */
  margin-left: auto;
  margin-right: auto;
}

/* Centre and border the login card */
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid black;
  padding: 20px;
  margin: 1rem;
}

input {
  margin-bottom: 20px;
}
</style>
